import { AbortableAPI, API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

import { ContractorDTO, ProviderDTO } from './dto';

const { C300 } = GW_SERVICES_PREFIXES;

// Получение УК
export const GetProviders = (params: IParams, signal?: AbortSignal) =>
  AbortableAPI.get<{ data: ProviderDTO[] }>(`/${C300}/search/provider/`, {
    params,
    signal,
  });

// Получение списка УК по по идентификаторам
export const GetProvidersByIds = (params: IParams, signal?: AbortSignal) =>
  AbortableAPI.get<ContractorDTO[]>(`/${C300}/models/providers/`, {
    params,
    signal,
  });

// Получение контактных номеров УК
export const GetProviderPhones = () => {
  return API.get(`/${C300}/phones/provider/`);
};

export const CreateProviderPhone = (data: IParams) => {
  return API.gatewayPost(`/${C300}/phones/provider/create/`, data);
};

export const UpdateProviderPhone = (data: IParams) => {
  return API.gatewayPatch(`/${C300}/phones/provider/update/`, undefined, data);
};

export const DeleteProviderPhone = (data: IParams) => {
  return API.gatewayPatch(`/${C300}/phones/provider/delete/`, undefined, data);
};

/* Получение списка владельцев котельных */
export const GetBusinessTypeProviders = () =>
  API.get(`/${C300}/boilers/provider/business_type/`);

// Запрос провайдеров, создавших документы для ркц (для Документооборота)
export const GetDocsProviders = () =>
  API.get(`/${C300}/models/docs_departments/providers/`);

/* Получение полного списка организаций */
export const GetProvidersList = (params: IParams) =>
  API.get('/providers/list/', undefined, params);

export const GetContractors = (params?: { houses: string[] }) =>
  AbortableAPI.get<ContractorDTO[]>(`/${C300}/models/news/contractors/`, {
    params,
  });

export const GetProvidersAbbreviated = (params: IParams) =>
  API.get(`/${C300}/models/providers_abbreviated/`, undefined, params);
